// ** Icons Import
import { Home, Circle, AlertTriangle } from "react-feather";

export default [
  {
    id: "risk",
    title: "Risk",
    icon: <AlertTriangle size={20} />,
    badge: "light-warning",
    // badgeText: "2",
    children: [
      {
        id: "riskySales",
        title: "Risky Sales",
        icon: <Circle size={12} />,
        navLink: "/risk/risky-sales",
      },
      {
        id: "swearWords",
        title: "Bad Words",
        icon: <Circle size={12} />,
        navLink: "/risk/banned-words",
      },
      {
        id: "bannedAccounts",
        title: "Banned Accounts",
        icon: <Circle size={12} />,
        navLink: "/risk/banned-accounts",
      },
      // {
      //   id: "suspiciousAccounts",
      //   title: "Suspicious Accounts",
      //   icon: <Circle size={12} />,
      //   navLink: "/risk/suspicious-accounts",
      // },
    ],
  },
];
